<template>
  <div class="absolute fill-height events-page">
    <Loader v-if="loading" skin="light"></Loader>
    <div v-else class="absolute fill-height pb-3 gui-flex gui-flex-rows">
      <v-toolbar
      color="blue accent-3"
      dark
      extended
      flat
      class="toolbar__fixed"
        >
      </v-toolbar>
      <!-- Dialog Vytvořit kategorii -->
      <v-dialog
        v-model="dialogCreate"
        persistent
        max-width="700px"
        transition="dialog-transition"
        v-if="dialogCreate"
      >
        <v-card class="no__padding">
          <v-card-title :class="{'py-0' : $vuetify.breakpoint.xs}">
            <h2>Vytvořit novou kategorii</h2>
          </v-card-title>
          <v-card-text class="pa-0 pr-2" :class="{'pt-0 pb-2' : $vuetify.breakpoint.smAndUp}">
            <v-form ref="createForm" v-model="valid" lazy-validation>
              <v-layout row wrap>
                <v-flex xs6>
                  <v-text-field label="Název" v-model="newItem.nazev_kategorie" class="mx-2" :rules="rulesRequired"></v-text-field>
                </v-flex>
                <v-flex xs6>
                  <v-select
                    v-model="newItem.jazyk"
                    :items="languages"
                    :rules="rulesRequired"
                    label="Jazyk"
                  ></v-select>
                </v-flex>
              </v-layout>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-3 elevation-0" dark @click="create" :loading="sending">Vytvořit</v-btn>
            <v-btn color="grey lighten-3 elevation-0" @click="dialogCreate=false" v-if="!sending">Zavřít</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- Dialog Upravit kategorii -->
      <v-dialog
        v-model="dialogEdit"
        persistent
        max-width="700px"
        transition="dialog-transition"
        v-if="dialogEdit"
      >
        <v-card class="no__padding">
          <v-card-title :class="{'py-0' : $vuetify.breakpoint.xs}">
            <h2>Upravit kategorii</h2>
          </v-card-title>
          <v-card-text class="pa-0 pr-2" :class="{'pt-0 pb-2' : $vuetify.breakpoint.smAndUp}">
            <v-form ref="createForm" v-model="valid" lazy-validation>
              <v-layout row wrap>
                <v-flex xs6>
                  <v-text-field label="Název" v-model="editItem.name" class="mx-2" :rules="rulesRequired"></v-text-field>
                </v-flex>
                <v-flex xs6>
                  <v-select
                    v-model="editItem.jazyk"
                    :items="languages"
                    :rules="rulesRequired"
                    label="Jazyk"
                  ></v-select>
                </v-flex>
              </v-layout>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-3 elevation-0" dark @click="editCategory()" :loading="sending">Uložit</v-btn>
            <v-btn color="grey lighten-3 elevation-0" @click="dialogEdit=false" v-if="!sending">Zavřít</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- Dialog Smazat -->
      <v-dialog
        v-model="dialogDelete"
        persistent
        max-width="700px"
        transition="dialog-transition"
        v-if="dialogDelete"
      >
        <v-card class="no__padding">
          <v-card-title :class="{'py-0' : $vuetify.breakpoint.xs}">
            <h2>Smazat kategorii {{ deleteItem.name }}?</h2>
          </v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-3 elevation-0" dark @click="deleteCategory()" :loading="sending">Smazat</v-btn>
            <v-btn color="grey lighten-3 elevation-0" @click="dialogDelete=false" v-if="!sending">Zrušit</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-card flat class="no__radius mr-3 ml-3 table-wrap__padding wrap-scrollbar gui-flex-fill-rest gui-flex gui-flex-rows elevation-1">
        <div class="gui-flex gui-flex-rows">
          <div class="custom-scrollbar">
            <v-layout row wrap>
              <v-flex grow>
                <h2>Videoblog</h2>
                <h3>Přehled kategorií</h3>
              </v-flex>
              <v-flex shrink>
                <v-btn color="blue darken-3" class="ma-0 mb-3" :class="{'v-btn--block': $vuetify.breakpoint.xs}" outline  @click="createClick()">
                  <v-icon class="mr-2">add</v-icon>
                  Vytvořit kategorii
                </v-btn>
              </v-flex>
            </v-layout>
            <div class="table-border__radius">
              <v-data-table
                :headers="headers"
                :items="items"
                :loading="loadingTable"
                :hide-actions="true"
              >
                <template slot="items" slot-scope="props">
                  <td>
                    {{ props.item.nazev_kategorie }}
                  </td>
                  <td>
                    <span v-if="props.item.jazyk == 'cs'">Česky</span>
                    <span v-else-if="props.item.jazyk == 'en'">Anglicky</span>
                  </td>
                  <td class="text-xs-right">
                    <v-btn fab small depressed v-if="props.index>0" avatar @click="moveUp(props.index)"><v-icon small>keyboard_arrow_up</v-icon></v-btn>
                    <v-btn fab small depressed v-if="props.index<items.length-1" avatar @click="moveDown(props.index)"><v-icon small>keyboard_arrow_down</v-icon></v-btn>
                  </td>
                  <td class="text-xs-right">
                    <v-btn @click="dialogEdit=true; editItem.id=props.item.id; editItem.name=props.item.nazev_kategorie; editItem.poradi=props.item.poradi; editItem.jazyk=props.item.jazyk" color="primary" class="elevation-0 mr-0">
                      <v-icon small class="mr-2">remove_red_eye</v-icon> Upravit
                    </v-btn>
                    <v-btn @click="dialogDelete=true; deleteItem.id=props.item.id; deleteItem.name=props.item.nazev_kategorie" color="red" dark class="elevation-0 mr-0">
                      <v-icon small class="mr-2">delete</v-icon> Smazat
                    </v-btn>
                  </td>
                </template>
              </v-data-table>
            </div>
          </div>
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
import Base from '@/pages/Base'
export default {
  extends: Base,
  data () {
    return {
      loading: true,
      updateItem: {},
      totalItems: {},
      newItem: {},
      editItem: {},
      deleteItem: {},
      editPor: {},
      sending: false,
      headers: [
          { text: 'Název kategorie', value: 'nazev_kategorie', sortable: false },
          { text: 'Jazyk', value: 'jazyk', sortable: false },
          { text: 'Pořadí', value: 'poradi', align: 'right' },
          { text: '', value: null, sortable: false, align: 'right', width: 200 },
        ],
      items: [],
      languages: [
        { text: 'Česky', value: 'cs' },
        { text: 'Anglicky', value: 'en' },
      ],
      loadingTable: true,
      dialogCreate: false,
      dialogEdit: false,
      dialogDelete: false,
      valid: true,
      rulesRequired: [
        (v) => !!v || "Pole je vyžadováno"
      ],
    }
  },
  mounted: function() {
    this.load();
  },
  methods: {
    load: function(v) {
      window.api.get("videoblog/kategorie/all").then(function(_body) {
        this.items = _body;
        this.loadingTable = false;
        this.loading = false;
      }.bind(this)).catch(function(err) {
        console.log(err);
      }.bind(this));
    },
    createClick () {
      this.newItem = {
        nazev: ""
      };
      this.dialogCreate = true;
    },
    create () {
      if (this.$refs.createForm.validate()) {
        this.sending = true;
        window.API.post("videoblog/kategorie/new", this.newItem).then(function(body) {
          this.sending = false;
          this.dialogCreate = false;
          this.load();
        }.bind(this)).catch(function(err) {
          console.log(err);
          this.sending = false;
        }.bind(this));
      }
    },
    editCategory () {
      if (this.$refs.createForm.validate()) {
        this.sending = true;
        window.API.put("videoblog/kategorie/"+this.editItem.id, this.editItem).then(function(body) {
          this.sending = false;
          this.dialogEdit = false;
          this.loading = true;
          this.load();
        }.bind(this)).catch(function(err) {
          console.log(err);
          this.sending = false;
        }.bind(this));
      }
    },
    moveDown: function(index) {
      var _sort = this.items.map(function(e) { return e.id });
      var id = _sort[index];
      _sort.splice(index, 1);
      _sort.splice(index+1, 0, id);
      this.editPoradi(_sort);
    },
    moveUp: function(index) {
      var _sort = this.items.map(function(e) { return e.id });
      var id = _sort[index];
      _sort.splice(index, 1);
      _sort.splice(index-1, 0, id);
      this.editPoradi(_sort);
    },
    editPoradi (_sort) {
      window.API.put("videoblog/kategorie/poradi", { kategorie: _sort }).then(function(body) {
        //this.loading = true;
        this.load();
      }.bind(this)).catch(function(err) {
        console.log(err);
      }.bind(this));
    },
    deleteCategory () {
      this.sending = true;
      window.API.delete("videoblog/kategorie/del/"+this.deleteItem.id).then(function(body) {
        this.sending = false;
        this.dialogDelete = false;
        this.load();
      }.bind(this)).catch(function(err) {
        console.log(err);
        this.sending = false;
      }.bind(this));
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/pages/VideoBlog/VideoBlogKategorie.vue